//      
import { invariant } from '../invariant';

                                                               

export default (droppable                    )             => {
  const frame              = droppable.frame;
  invariant(frame, 'Expected Droppable to have a frame');
  return frame;
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/get-frame.js